<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Compensation Summary page" @click="backToSummaryPage">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <details-menu :id="1" :userId="selectedUserId"></details-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="2" class="mt-0"></v-progress-linear> 
            </v-card>

            <!-- EMPLOYEE DETAILS -->
            <v-card v-if="userDetails" class="elevation-1 mt-5">
                <v-toolbar flat height="45">
                    <span class="font-weight-bold primary--text">EMPLOYEE DETAILS</span>
                    <v-spacer></v-spacer>
                    <v-btn @click="showAllEmployees" icon title="Select other employee">
                        <v-icon>list</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap> 
                        <v-flex xs12 sm6>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employee Name :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <v-chip @click="viewUserProfile(userDetails, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(userDetails.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{userDetails.firstName}} {{userDetails.lastName}}</b>
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employee Id : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                <b>{{userDetails.employeeId}}</b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Position : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b>{{userDetails.position}}</b>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Hire Date : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                <b>
                                    <span v-if="userDetails.hireDate!=null">{{userDetails.hireDate|moment('MMM DD, YYYY')}}</span>
                                    <span v-else class="orange--text">Not updated</span>
                                </b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employment Status :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b v-if="isDeactivted" :class="commonfn.getStatusColor(userDetails.employmentStatus)">{{commonfn.getStatusDescription(userDetails.employmentStatus)}} on {{ userDetails.deactivatedOn | moment('MMM DD, YYYY') }}</b>
                                    <b v-else-if="isResignedOrTerminated" :class="commonfn.getStatusColor(userDetails.employmentStatus)">{{commonfn.getStatusDescription(userDetails.employmentStatus)}} on {{ userDetails.endDate | moment('MMM DD, YYYY') }}</b>
                                    <b v-else :class="commonfn.getStatusColor(userDetails.employmentStatus)">{{commonfn.getStatusDescription(userDetails.employmentStatus)}}</b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Salary Type :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b>{{commonfn.getSalaryTypeName(userDetails.salaryType)}}</b>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <!-- SALARY & PAY DETAILS -->
            <v-card v-if="userDetails" class="elevation-1 mt-5">
                <v-toolbar flat height="45">
                    <span class="font-weight-bold primary--text">SALARY & PAY HISTORY</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="hasAddRights" fab class="primary" small @click="add">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="isMonthlySalaryType?header_compensation_history:header_compensation_hourly_history"
                    :items="salaryHistory"
                    :expand="expand" 
                    item-key="compensationId"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="isMonthlySalaryType?header_compensation_history.length:header_compensation_hourly_history.length" class="pa-1">
                                <v-card class="rounded-5">
                                    <v-toolbar flat height="40" class="transparent">
                                        <v-chip small>{{props.item.fiscalYear}}</v-chip>
                                        <v-spacer></v-spacer>
                                        <v-menu left offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small v-bind="attrs" v-on="on" @click.stop :loading="loading_action[props.index]">
                                                    <v-icon small>more_vert</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-tile v-show="hasEditRights && (isCreated(props.item)||isRejected(props.item))" @click="edit(props.item, props.index)" title="Click to edit this record">
                                                    <v-list-tile-title>Edit</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasEditRights && isCreated(props.item)" @click="forReview(props.item, props.index)" title="Click to set this record to For Review">
                                                    <v-list-tile-title>For Review</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isRejected(props.item))" @click="approve(props.item, props.index)" title="Click to Approve this record">
                                                    <v-list-tile-title>Approve</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isApproved(props.item))" @click="reject(props.item, props.index)" title="Click to Reject this record">
                                                    <v-list-tile-title>Reject</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasDeleteRights && (isCreated(props.item)||isRejected(props.item))" @click="showDeleteConfirmation(props.item, props.index)" title="Click to Delete this record">
                                                    <v-list-tile-title>Delete</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar>
                                    <v-divider></v-divider>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Pay Grade</div>
                                                    <div>{{props.item.payGrade}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div v-if="isMonthlySalaryType">
                                                        <div class="caption grey--text text--darken-1">Monthly Salary</div>
                                                        <div>{{numFormat.formatNumber(props.item.monthlyBasicSalary)}}</div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="caption grey--text text--darken-1">Hourly Rate</div>
                                                        <div>{{numFormat.formatNumber(props.item.hourlySalary)}}</div>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">OT Pay Eligible</div>
                                                    <div v-if="props.item.otPayEligible">Yes</div>
                                                    <div v-else>No</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">ND Pay Eligible</div>
                                                    <div v-if="props.item.ndPayEligible">Yes</div>
                                                    <div v-else>No</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Effective Date</div>
                                                    <div>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</div>
                                                </v-flex>
                                                 <v-flex xs4 v-if="isMonthlySalaryType">
                                                    <div class="caption grey--text text--darken-1">Annual Salary</div>
                                                    <div>{{numFormat.formatNumber((props.item.monthlyBasicSalary*12))}}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Status</div>
                                                    <div :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</div> 
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>

                        <!-- desktop view -->
                        <tr v-else @click="props.expanded=!props.expanded" class="clickable" title="Click to view other details">
                            <td>{{props.item.fiscalYear}}</td>
                            <td>{{props.item.payGrade}}</td>
                            <td class="text-xs-right">
                                <span v-if="isMonthlySalaryType">{{numFormat.formatNumber(props.item.monthlyBasicSalary)}}</span>
                                <span v-else>{{numFormat.formatNumber(props.item.hourlySalary)}}</span>
                            </td>
                            <td v-if="isMonthlySalaryType" class="text-xs-right">
                                {{numFormat.formatNumber((props.item.monthlyBasicSalary*12))}}
                            </td>
                            <td>
                                <span v-if="props.item.otPayEligible">Yes</span>
                                <span v-else>No</span>
                            </td>
                            <td>
                                <span v-if="props.item.ndPayEligible">Yes</span>
                                <span v-else>No</span>
                            </td>
                            <td>
                                {{ props.item.effectiveDate | moment('MMM DD, YYYY')}}
                            </td>
                            <td>
                               <span :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</span> 
                            </td>
                            <td title="Click to view action menu" @click.stop>
                                <v-menu left offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop :loading="loading_action[props.index]">
                                            <v-icon small>more_vert</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-tile v-show="hasEditRights && (isCreated(props.item)||isRejected(props.item))" @click="edit(props.item, props.index)" title="Click to edit this record">
                                            <v-list-tile-title>Edit</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasEditRights && isCreated(props.item)" @click="forReview(props.item, props.index)" title="Click to set this record to For Review">
                                            <v-list-tile-title>For Review</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isRejected(props.item))" @click="approve(props.item, props.index)" title="Click to Approve this record">
                                            <v-list-tile-title>Approve</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isApproved(props.item))" @click="reject(props.item, props.index)" title="Click to Reject this record">
                                            <v-list-tile-title>Reject</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasDeleteRights && (isCreated(props.item)||isRejected(props.item))" @click="showDeleteConfirmation(props.item, props.index)" title="Click to Delete this record">
                                            <v-list-tile-title>Delete</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:expand="props">
                        <v-card flat>
                            <v-card-actions class="ml-15 mr-15">
                                <v-chip small>Created On:&nbsp;<b>{{ props.item.createdOn | moment('MMM DD, YYYY')}}</b></v-chip>
                                <v-spacer></v-spacer>
                                <span>
                                    Created By:
                                    <v-chip small>
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdByUser.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{props.item.createdByUser.firstName}} {{props.item.createdByUser.lastName}}</b>
                                    </v-chip>
                                </span>
                                <span v-if="isApproved(props.item)">
                                    Approved By:
                                    <v-chip small>
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.approvedByUser.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{props.item.approvedByUser.firstName}} {{props.item.approvedByUser.lastName}}</b>
                                    </v-chip>
                                </span>
                                <span v-if="isRejected(props.item)">
                                    Rejected By:
                                    <v-chip small>
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.updatedByUser.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{props.item.updatedByUser.firstName}} {{props.item.updatedByUser.lastName}}</b>
                                    </v-chip>
                                </span>
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-data-table>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" ref="commentsRef" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogAddEditSalary" persistent width="700">
            <add-edit-salary ref="addEditSalaryRef" :dialogAddEditSalary.sync="dialogAddEditSalary" @send="getSalaryHistory(false)"></add-edit-salary>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteRecord"></delete>
        </v-dialog>
        <v-dialog v-model="dialogAllEmployees" persistent width="700">
            <view-all-employees ref="refAllEmployees" :dialogAllEmployees.sync="dialogAllEmployees" @send="viewOtherEmployee"></view-all-employees>
        </v-dialog>
        
        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import compAllocApi from '@/api/compallocation'
import commonfn from '@/common/functions'       //for refactor
import awsS3Helper from '@/helpers/aws-s3'
import salaryTypes from '@/constants/salary-types'
import numFormat from '@/common/num_format'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import { hasAddRights, hasEditRights, hasApproverRights, hasDeleteRights } from '@/helpers/access-permissions'

export default {     
    name: 'SalaryAndPay',
    metaInfo: {
        title: 'Salary & Pay Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Salary & Pay Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'add-edit-salary': () => import('@/components/Allocation/EditPayGradeSalary'),
        'view-all-employees': () => import('@/components/Allocation/AllCompensationEmployees'),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'details-menu': () => import('@/components/Allocation/CompensationDetailsMenu'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            numFormat,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            header_compensation_history: [
                {text: 'Year',align: 'left',value: 'fiscalYear',width: '5%', sortable:true},
                {text: 'Pay Grade',align: 'left',value: 'payGrade',width: '10%', sortable:true},
                {text: 'Monthly Salary',align: 'right',value: 'monthlyBasicSalary',width: '10%', sortable:true},
                {text: 'Annual Salary',align: 'right',value: '',width: '10%', sortable:false},
                {text: 'OT Pay Eligible',align: 'left',value: 'otPayEligible',width: '10%', sortable:true},
                {text: 'ND Pay Eligible',align: 'left',value: 'ndPayEligible',width: '10%', sortable:true},
                {text: 'Effective Date',align: 'left',value: 'effectiveDate',width: '10%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',width: '5%', sortable:true},
                {text: 'Action',align: 'left',value: '',width: '5%', sortable:false},
            ],
            header_compensation_hourly_history: [
                {text: 'Year',align: 'left',value: 'fiscalYear',width: '5%', sortable:true},
                {text: 'Pay Grade',align: 'left',value: 'payGrade',width: '10%', sortable:true},
                {text: 'Hourly Rate',align: 'right',value: 'hourlySalary',width: '10%', sortable:true},
                {text: 'OT Pay Eligible',align: 'left',value: 'otPayEligible',width: '10%', sortable:true},
                {text: 'ND Pay Eligible',align: 'left',value: 'ndPayEligible',width: '10%', sortable:true},
                {text: 'Effective Date',align: 'left',value: 'effectiveDate',width: '10%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',width: '5%', sortable:true},
                {text: 'Action',align: 'left',value: '',width: '5%', sortable:false},
            ],
            dialogAllEmployees: false,
            dialogAddEditSalary: false,
            dialogDelete: false,
            deleteData: null,
            deleteIndex: null,
            expand: false,
            error: false,
            errorMessage: '',
            loading: false,
            loading_action: [],
            userDetails: null,
            salaryHistory: []
        }
    },
    methods: {
        viewOtherEmployee(userId){
            this.$router.push(`/compensation/allocation/${userId}/salary-history`)
        },
        showAllEmployees() {
            this.$refs.refAllEmployees.getEmployees()
            this.dialogAllEmployees = true
        },
        backToSummaryPage() {
            const selectedYear = userPrefs.getSelectedCompensationYear()
            const currentFiscalPeriodId = this.$store.state.fiscalPeriods.find(x => x.fiscalYear == selectedYear).fiscalPeriodId
            this.$router.push(`/compensation/allocation/${currentFiscalPeriodId}/${this.selectedUserId}`)
        },
        async reject(data, index){
            try {
                this.$set(this.loading_action, index, true)

                await compAllocApi.reject(data.compensationId)   
                await this.getSalaryHistory(false)

                this.$set(this.loading_action, index, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async approve(data, index){
            try { 
                this.$set(this.loading_action, index, true)

                await compAllocApi.approve(data.compensationId)  
                await this.getSalaryHistory(false)

                this.$set(this.loading_action, index, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async forReview(data, index){           
            try {
                this.$set(this.loading_action, index, true)

                await compAllocApi.forReview(data.compensationId)  
                await this.getSalaryHistory(false)

                this.$set(this.loading_action, index, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        showDeleteConfirmation(data, index) {
            this.deleteData = data
            this.deleteIndex = index
            this.$refs.refDeleteComponent.setMessage("Delete this Salary & Pay record?")
            this.dialogDelete = true
        },
        async deleteRecord(){
             try {
                this.$set(this.loading_action, this.deleteIndex, true)

                await compAllocApi.delete(this.deleteData.compensationId)
                await this.getSalaryHistory(false)
                this.dialogDelete = false

                this.$set(this.loading_action, this.deleteIndex, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        add(data){
           var paramData = {
                mode: 'Add',
                userId: this.userDetails.userId,
                salaryType: this.userDetails.salaryType,
                compensationId: data.compensationId
            }
            this.$refs.addEditSalaryRef.setAdd(paramData)
            this.dialogAddEditSalary = true
        },
        edit(data){           
            var paramData = {
                mode: 'Update',
                userId: this.userDetails.userId,
                salaryType: this.userDetails.salaryType,
                compensationId: data.compensationId,
                fiscalPeriodId: data.fiscalPeriodId,
                payGradeId: data.payGradeId,
                monthlyBasicSalary: data.monthlyBasicSalary,
                hourlySalary: data.hourlySalary,
                otPayEligible: data.otPayEligible,
                ndPayEligible: data.ndPayEligible,
                effectiveDate: data.effectiveDate,
            }
            this.$refs.addEditSalaryRef.setEdit(paramData)
            this.dialogAddEditSalary = true
        },
        isCreated(data){
            return data.status == commonfn.getStatusCode('Created')
        },
        isForReview(data){
            return data.status == commonfn.getStatusCode('For Review')
        },
        isRejected(data){
            return data.status == commonfn.getStatusCode('Rejected')
        },
        isApproved(data){
            return data.status == commonfn.getStatusCode('Approved')
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        async getSalaryHistory(displayLoading) {
            try {
                this.loading = displayLoading
                const response = await compAllocApi.getSalaryHistory(this.selectedUserId)
                if (response && response.status == 200) {
                    this.userDetails = response.data.user
                    this.salaryHistory = response.data.items
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getSalaryHistory(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'Salary & Pay Details'
        })

        this.getSalaryHistory(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        selectedUserId: {
            immediate: true, // runs on first load
            async handler(newUserId, oldUserId) {
                if (!newUserId) return

                // optional guard
                if (newUserId === oldUserId) return

                await this.getSalaryHistory(false)
            }
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        selectedUserId() {
            return this.$route.params.userId
        },
        isMonthlySalaryType() {
            if (this.userDetails) {
                const salaryType = salaryTypes.find(x => x.salaryType == this.userDetails.salaryType)
                if (salaryType)
                    return salaryType.name == 'Monthly'
                return true
            }
        },
        isResignedOrTerminated() {
            return this.userDetails.employmentStatus == commonfn.getStatusCode('Resigned') ||
                    this.userDetails.employmentStatus == commonfn.getStatusCode('Terminated')
        },
        isDeactivted() {
            return this.userDetails.employmentStatus == commonfn.getStatusCode('Deactivated')
        },
        isMobile() {
            return window.innerWidth < 600
        },
        pageQueryId() {
            return `salary-history-${this.selectedUserId}`
        },
        commentsData() {
            if (!this.loading) {
                //for refactoring, separate params of comments notif 
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null, 
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.allocation,
                    notificationTypeId: notificationTypes.allocation
                }
            }
        },
    }
}
</script>
<style scoped>
.form-data {
    padding:0px 20px 0px 50px;
}
.form-data-mobile {
    padding:0px 0px 0px 10px;
}
.section-layout {
    padding:5px 23px 5px 23px;
}
</style>